// Format helpers used by both public landing and admin pages.

export function formatDate(iso) {
  if (!iso) return '—';
  try {
    return new Intl.DateTimeFormat('es-EC', {
      dateStyle: 'long',
      timeStyle: 'short',
      hour12: false,
      timeZone: 'America/Guayaquil',
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}

export function formatTime(iso) {
  if (!iso) return '—';
  try {
    return new Intl.DateTimeFormat('es-EC', {
      timeStyle: 'short',
      hour12: false,
      timeZone: 'America/Guayaquil',
    }).format(new Date(iso));
  } catch {
    return iso;
  }
}

export function truncate(text, n = 500) {
  if (text == null) return '';
  const str = String(text);
  return str.length > n ? `${str.slice(0, n)}…` : str;
}

// Maps the backend tri-state (0|1|-1) to a Spanish label used in tables
// and stats cards.
export function confirmadoLabel(state) {
  if (state === 1) return 'Confirmado';
  if (state === -1) return 'Rechazado';
  return 'Pendiente';
}

export function confirmadoTone(state) {
  if (state === 1) return 'success';
  if (state === -1) return 'error';
  return 'muted';
}
